import {
    MASTER_DATA_ERROR_ACTION_TYPE,
    MASTER_DATA_FETCH_START_ACTION_TYPE,
    MASTER_DATA_FETCH_SUCCESS_ACTION_TYPE,
    MASTER_DATA_RESET_ACTION_TYPE,
    MasterDataAction
} from 'actions/masterData/MasterDataActionsTypes';
import { MasterDataState, MasterDataStatus } from 'reducers/masterData/MasterDataState';
import { Reducer } from 'redux';
import { emptyMasterData } from 'types/MasterData';

const initialState: MasterDataState = {
    data: emptyMasterData,
    status: MasterDataStatus.Initial,
    loading: false
};

export const masterDataReducer: Reducer<MasterDataState, MasterDataAction> = (
    state = initialState,
    action
) => {
    switch (action.type) {
        case MASTER_DATA_RESET_ACTION_TYPE:
            return {
                ...initialState
            };
        case MASTER_DATA_FETCH_START_ACTION_TYPE:
            return {
                ...state,
                loading: true,
                status: MasterDataStatus.Fetching
            };
        case MASTER_DATA_FETCH_SUCCESS_ACTION_TYPE:
            return {
                ...state,
                loading: false,
                status: MasterDataStatus.FetchSuccess,
                data: action.payload.masterData
            };
        case MASTER_DATA_ERROR_ACTION_TYPE:
            return {
                ...state,
                status: MasterDataStatus.Error,
                loading: false
            };
        default:
            return state;
    }
};
